<template>
  <Benefit>
    {{ i18n(translations.label) }}
  </Benefit>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import Benefit from '../Benefit/Benefit.vue'

import translations from './ParentalOption.translations'

const i18n = useI18n()
</script>
